module.exports = ".panel{\n    color: black;\n    font-family: 'Gaegu';\n    font-size: 140%;\n}\n.panel-body{\n    text-align: center;\n}"